import React from 'react';

// eslint-disable-next-line max-len
const PARENTSTARS_LOGO = '/themes/theme/parentstars/logo.jpeg';

const minHeight200 = {
  'min-height': '200px',
};

const minHeight100 = {
  'min-height': '100px',
};

const textAlignCentre = {
  'text-align': 'center',
  'font-size': '15px',
};

const textAlignCentre50p = {
  'text-align': 'center',
  'font-size': '12px',
  padding: '0 20px',
};


const PARENTSTARSTheme = {
  headerLogo: {
    src: PARENTSTARS_LOGO,
    alt: 'PARENTSTARS Logo',
    size: 70,
  },
  darkLogo: {
    src: PARENTSTARS_LOGO,
    alt: 'PARENTSTARS Logo',
    size: 70,
  },
  linkStyle: {
    color: '#c9378d',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #302c6b',
    height: 80,
  },
  title: 'ParentStars',
  organisationId: '715455ac-7059-4d1c-9ed6-9d420c00fde3',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="150"
        src={PARENTSTARS_LOGO} alt="PARENTSTARS Logo"
      />
      <br /><br />
    </div>
  ),
  welcomeHtml: () => (
    <div style={minHeight100}>
      <p style={textAlignCentre}>Welcome to ParentStars</p>
      <br />
      <p style={textAlignCentre50p}>Join our network of talented parent
      creators for the opportunity to collaborate with more of the UK’s leading children’s brands.</p>
      <br />
    </div>
  ),
  signUpHtml: () => (
    <div style={minHeight100}>
      <p style={textAlignCentre}>Ready to Create Your Account…</p>
      <br />
    </div>
  ),
  finishedHtml: () => (
    <div style={minHeight100}>
      <p style={textAlignCentre}>Sign-up completed</p>
      <br />
    </div>
  ),
  shareSite: 'https://share.parentstars.co.uk',
  isFullWhiteLabel: true,
};

export default PARENTSTARSTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/parentstars.js
 **/